import gql from 'graphql-tag';

export const GET_LENDER_TOTAL_COST_COMPARISON = gql`
  query LenderTotalCostComparison($input: LenderPerformanceReportInput!) {
    lenderPerformance {
      totalCostComparison(input: $input) {
        success
        error
        entity {
          lenderProfileId
          lenderName
          docFee
          totalCost
        }
      }
    }
  }
`;
